import React, { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import DigitalAssetSelectors from '../../../../modules/domain/digitalAsset/selectors'
import { useAction } from '@agro-club/frontend-shared'
import DigitalAssetActions from '../../../../modules/domain/digitalAsset/duck'
import { DigitalAssetDocumentType } from '../../../../types/entities'
import { DigitalAssetListRequestFilter } from '../../../../modules/domain/digitalAsset/types'
import GenericSelect from '../../Generics/GenericSelect'

/* Select component for filtering digital assets using the document type property
 * Reference: {@link DigitalAssetDocumentType}*/
const DAFileTypeFilterSelect: React.FC = () => {
  const { t } = useTranslation('digitalAsset')
  const filter = useSelector(DigitalAssetSelectors.filter)
  const filterUpdated = useAction(DigitalAssetActions.filterUpdated)
  let { document_type } = filter
  const [fileTypes, setFileTypes] = useState<DigitalAssetDocumentType[]>([])

  const fileTypeSelectItems = Object.keys(DigitalAssetDocumentType).map((e) => {
    return { label: DigitalAssetDocumentType[e], value: DigitalAssetDocumentType[e] }
  })

  const addToFilter = (documentTypes: DigitalAssetDocumentType[]) => {
    setFileTypes(() => [...documentTypes])
  }

  const handleFilterChange = useCallback(
    (newFilterValue: Partial<DigitalAssetListRequestFilter>) => {
      filterUpdated({ ...filter, ...newFilterValue })
    },
    [filterUpdated, filter],
  )

  const executeFilter = () => {
    document_type = fileTypes as DigitalAssetDocumentType[]
    handleFilterChange({ document_type })
  }

  return (
    <GenericSelect
      mode="multiple"
      maxTagCount="responsive"
      placeholder={t('select.fileType')}
      title={t('select.fileType')}
      options={fileTypeSelectItems}
      applyButtonLabel={t('button.applyFilter')}
      onApply={executeFilter}
      onChange={addToFilter}
      parentContainerFlex={1}
    />
  )
}

export default DAFileTypeFilterSelect
